import React from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Footer from '../components/Footer';
import Header from '../components/Header';

const Iletisim = () => {
    return (
        <>
            <Helmet>
                <title>İletişim - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="Legalbul.com iletişim sayfası." />
            </Helmet>

            <Header />
            <section className="container p-5 my-5 bg-white shadow-sm">
                <ol className="breadcrumbnav">
                    <li>
                        <Link to="/">Ana Sayfa</Link>
                    </li>
                    <li>
                        İletişim
                    </li>
                </ol>
                <div>
                    <h1>İletişim</h1>
                    Legalbul.com ile ilgili herhangi bir sorunuz, öneriniz veya geri bildiriminiz varsa lütfen bize
                    e-posta göndermekten çekinmeyin. Ayrıca, yeni bir hesaplama türü öneriniz varsa veya talepleriniz
                    bulunuyorsa, bizimle paylaşmanızdan mutluluk duyarız.
                </div>
                <div className="py-4">
                    <strong>E-posta Adresi: </strong>
                    <span>iletisim@legalbul.com</span>
                </div>
                <div>
                    Bizimle iletişime geçtiğiniz için teşekkür ederiz.
                </div>
            </section>
            <Footer />
        </>
    );
};

export default React.memo(Iletisim);
